import { Button } from "@/components/Primitives/Button"
import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { cn } from "@/lib/utils/utils"
import { useConfig } from "@/hooks/useConfig"

interface FooterButton {
  show: boolean
  text: string
  href: string
  showQuestButtons?: boolean
}

const getFooterButton = (pathname: string): FooterButton => {
  if (pathname.startsWith("/quest/")) {
    return {
      show: true,
      text: "",
      href: "",
      showQuestButtons: true,
    }
  }

  switch (pathname) {
    case "/home":
      return {
        show: true,
        text: "footer_continue_button",
        href: "/quest",
      }
    case "/quest":
      return {
        show: false,
        text: "",
        href: "",
      }
    default:
      return {
        show: false,
        text: "",
        href: "",
      }
  }
}

export function PageFooter() {
  const location = useLocation()
  const pathname = location.pathname
  const { t } = useConfig()
  const footerButton = getFooterButton(pathname)

  if (!footerButton.show) return null

  if (footerButton.showQuestButtons) {
    return (
      <div className={cn("border-t pt-4")}>
        <div className={cn("flex justify-end gap-4")}>
          <Button variant="outline">{t("footer_complete_later")}</Button>
          <Button>{t("footer_mark_completed")}</Button>
        </div>
      </div>
    )
  }

  return (
    <div className={cn("border-t pt-4")}>
      <Link to={footerButton.href} className="block">
        <Button className={cn("w-full")}>{t(footerButton.text)}</Button>
      </Link>
    </div>
  )
}
